import * as React from 'react';
import { Link } from 'react-router-dom';

import './noPlan.scss';

export interface NoPlanProps {}

export const NoPlan: React.FunctionComponent<NoPlanProps> = (props) => (
	<>
		<p className="no_plan_message">
			You don't have a training plan yet! Once you complete your Edge Test, My Plan and Game Day modes will become
			available. In the meantime, you can utilize Open Gym mode.
		</p>
		<Link to="/training/evaluation" className="cta_btn no_plan_btn">
			Take Your Edge Test
		</Link>
	</>
);
export default NoPlan;
